module.exports = __webpack_public_path__ + "assets/img/chuzhi.9bf0e183.svg";